import React from 'react';
import { Button, Tooltip } from 'antd';
import { CiAlignBottom, CiAlignCenterH, CiAlignCenterV, CiAlignLeft, CiAlignRight, CiAlignTop, CiEdit } from 'react-icons/ci';
import { CgDistributeHorizontal, CgDistributeVertical } from 'react-icons/cg';
import { RiExpandHeightFill, RiExpandWidthFill, RiMergeCellsHorizontal } from 'react-icons/ri';
import { TbArrowAutofitWidth } from 'react-icons/tb';

interface ContextMenuProps {
  contextMenu: { x: number; y: number; open: boolean };
  selectedIdxs: Set<number>;
  contextRef: React.RefObject<HTMLDivElement>;
  onFitToFrame: () => void;
  onAlignSelected: (mode: 'left' | 'right' | 'top' | 'bottom' | 'hcenter' | 'vcenter') => void;
  onEqualizeSelected: (mode: 'w' | 'h') => void;
  onDistributeSelected: (axis: 'h' | 'v') => void;
  onBulkEdit?: () => void;
  onMergeSelected?: () => void;
  onClose: () => void;
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  contextMenu,
  selectedIdxs,
  contextRef,
  onFitToFrame,
  onAlignSelected,
  onEqualizeSelected,
  onDistributeSelected,
  onBulkEdit,
  onMergeSelected,
  onClose,
}) => {
  if (!contextMenu.open) return null;

  const handleAction = (action: () => void) => {
    action();
    onClose();
  };

  return (
    <div
      ref={contextRef}
      style={{
        position: 'absolute',
        left: contextMenu.x,
        top: contextMenu.y,
        zIndex: 1100,
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: 6,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        padding: 4,
        minWidth: 120
      }}
    >
      {selectedIdxs.size >= 1 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 28px)', gap: 4, marginBottom: 4 }}>
          <Tooltip title="Fit to frame">
            <Button size="small" type="text" style={{ height: 28 }} icon={<TbArrowAutofitWidth size={16} />} onClick={() => handleAction(onFitToFrame)} />
          </Tooltip>
          {selectedIdxs.size >= 2 && onBulkEdit && (
            <Tooltip title="Edit properties">
              <Button size="small" type="text" style={{ height: 28 }} icon={<CiEdit size={16} />} onClick={() => handleAction(onBulkEdit)} />
            </Tooltip>
          )}
          {selectedIdxs.size >= 2 && onMergeSelected && (
            <Tooltip title="Merge into one rectangle">
              <Button size="small" type="text" style={{ height: 28 }} icon={<RiMergeCellsHorizontal size={16} />} onClick={() => handleAction(onMergeSelected)} />
            </Tooltip>
          )}
        </div>
      )}
      
      {selectedIdxs.size >= 2 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 28px)', gap: 4, marginBottom: 4 }}>
          <Tooltip title="Align left">
            <Button size="small" type="text" style={{ height: 28 }} icon={<CiAlignLeft size={16} />} onClick={() => handleAction(() => onAlignSelected('left'))} />
          </Tooltip>
          <Tooltip title="Align right">
            <Button size="small" type="text" style={{ height: 28 }} icon={<CiAlignRight size={16} />} onClick={() => handleAction(() => onAlignSelected('right'))} />
          </Tooltip>
          <Tooltip title="Align top">
            <Button size="small" type="text" style={{ height: 28 }} icon={<CiAlignTop size={16} />} onClick={() => handleAction(() => onAlignSelected('top'))} />
          </Tooltip>
          <Tooltip title="Align bottom">
            <Button size="small" type="text" style={{ height: 28 }} icon={<CiAlignBottom size={16} />} onClick={() => handleAction(() => onAlignSelected('bottom'))} />
          </Tooltip>
          <Tooltip title="Align horizontal center">
            <Button size="small" type="text" style={{ height: 28 }} icon={<CiAlignCenterH size={16} />} onClick={() => handleAction(() => onAlignSelected('hcenter'))} />
          </Tooltip>
          <Tooltip title="Align vertical center">
            <Button size="small" type="text" style={{ height: 28 }} icon={<CiAlignCenterV size={16} />} onClick={() => handleAction(() => onAlignSelected('vcenter'))} />
          </Tooltip>
        </div>
      ) : null}
      {selectedIdxs.size >= 2 ? (
        <>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 28px)', gap: 4 }}>
          <Tooltip title="Same width">
            <Button size="small" type="text" style={{ height: 28 }} icon={<RiExpandWidthFill size={16} />} onClick={() => handleAction(() => onEqualizeSelected('w'))} />
          </Tooltip>
          <Tooltip title="Same height">
            <Button size="small" type="text" style={{ height: 28 }} icon={<RiExpandHeightFill size={16} />} onClick={() => handleAction(() => onEqualizeSelected('h'))} />
          </Tooltip>
        </div>
        {selectedIdxs.size >= 3 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 28px)', gap: 4, marginTop: 4 }}>
            <Tooltip title="Distribute horizontally">
              <Button size="small" type="text" style={{ height: 28 }} icon={<CgDistributeHorizontal size={16} />} onClick={() => handleAction(() => onDistributeSelected('h'))} />
            </Tooltip>
            <Tooltip title="Distribute vertically">
              <Button size="small" type="text" style={{ height: 28 }} icon={<CgDistributeVertical size={16} />} onClick={() => handleAction(() => onDistributeSelected('v'))} />
            </Tooltip>
          </div>
        )}
        </>
      ) : (
        <div style={{ fontSize: 11, color: '#888', padding: '2px 4px' }}>
          Select 2+ items to align
        </div>
      )}
    </div>
  );
};

export default ContextMenu;